import React, { useEffect,useState } from "react";
import format from "date-fns/format";
import classnames from "classnames";

import Modals from "../../../../components/uiElements/popupModal/modal";
import Button from "../../../../components/formElements/button/Button";

import CustomTextArea from "../../../../components/formElements/customTextArea/CustomTextArea";
import TemplateIcon from "../../../../components/uiElements/icons/onboardingIcons/TemplateIcon";
import { getUserData } from "../../../../utils/localStorage";
import Row from "../../../../components/uiElements/grid/Row";
import Col from "../../../../components/uiElements/grid/Col";
import ProfileIcon from "../../../../components/uiElements/icons/profileIcons/ProfileIcon";
import SpinnerBorder from "../../../../components/uiElements/loadingSpinner/SpinnerBorder";
import NoteModal from "../../../../components/uiElements/modal/NoteModel";
import { withRouter,useHistory } from "react-router";
import * as actions from "../../../../store/actions";
import { VALIDATE_TEMPLATE } from "../../../../store/actions/actionTypes";
import { connect } from "react-redux";

const CreateNotes = ({
  form,
  validateData,
  isOpen,
  closeModal,
  editMode,
  setEditMode,
  currentData,
  pid,
  setCurrentNoteData,
  clearCurrentNoteData,
  deleteScreenshot,
  addNote,
  addTemplatesNote,
  getAllPatientNotes,
  setValue,
  setComp,
  setVal,
}) =>
 {
  const [page,setPage]=useState(1)
  useEffect(() => {
    if (form && form.templatesValid) {
      closeModal()
    }

    form.templatesValid = false;
    // eslint-disable-next-line
  }, [form]);
  useEffect(() => {
    return () => {
      clearCurrentNoteData();
    };
    // eslint-disable-next-line
  }, []);

  //Label show and hide
  const [modal, setShowModal] = useState(false);
  const LabelShow = label => {
    return editMode ? "" : <span className="mydivlabelMain">{label}</span>;
  };

  return (
    <>
    {modal && (
        <NoteModal
        isOpen={modal}
        onLock={() =>
          addNote(() => {
            validateData(currentData)
            setShowModal(true);
            setValue(true)
            setVal(true)
            setComp(false)
            setPage(1)
            getAllPatientNotes(pid, "", page)
            
          })
        }
        onSaveAsTemplate={() => {
          addTemplatesNote(() => {
            addNote(() => {
              validateData(currentData)
              setShowModal(true);
              setValue(true)
              setVal(true)
              setComp(false)
              setPage(1)
              getAllPatientNotes(pid, "", page)
            });
          });
        }}
        closeModal={() => setShowModal(!modal)}
      />
      )}
      <Modals
        isOpen={isOpen}
        onRequestClose={() => closeModal}
        styles={{
          content: {
            minWidth: "55%",
            maxWidth: "80%",
            maxHeight: "90",
            width: "60%",
            height: "auto",
          },
        }}
      >
        <>
          <button
            onClick={closeModal}
            className="close modalCloseBtn1"
            aria-label="Close"
          > 
            <span aria-hidden="true">&times;</span>
          </button>
          <div className="patientNotes">
            <p className="text-center text-dark mt-3 font-weight-bold h6">
              Appointment Notes with Dr. {getUserData().firstName} {" "}{getUserData().lastName}
              <span className="ml-2">
                <>
                  {currentData?.created_by === getUserData().user ? (
                    <TemplateIcon
                      type="editIcon"
                      color="var(--icon-color)"
                      onClick={() => {
                        setEditMode(true);
                      }}
                    />
                  ) : null}
                </>
              </span>
            </p>
          </div>
          <div className="notesList">
            <div
              className={classnames(
                "note-template-container",
                editMode ? "mt-5" : "disable viewPatientNote"
              )}
            >
              {LabelShow("Note Name")}
              <CustomTextArea
                value={currentData?.note_name || ""}
                className={classnames(
                  editMode ? "mycontentdivMain" : "myoutline"
                )}
                error={form.note_name}
                label={editMode ? "Note Name" : ""}
                disabled={editMode && currentData?.is_locked}
                onChange={val => setCurrentNoteData({ note_name: val })}
                editMode={editMode}
              />

              {LabelShow("Chief Complaint")}
              <CustomTextArea
                value={currentData?.chief_complaint || ""}
                className={classnames(
                  editMode ? "mycontentdivMain" : "myoutline"
                )}
                error={form.chief_complaint}
                label={editMode ? "Chief Complaint" : ""}
                disabled={editMode && currentData?.is_locked}
                onChange={val => setCurrentNoteData({ chief_complaint: val })}
                editMode={editMode}
              />

              {/* Vitals */}
              {(currentData?.blood_pressure ||
                currentData?.pulse ||
                currentData?.oxygen_saturation ||
                currentData?.weight ||
                currentData?.height) &&
                !editMode && (
                  <>
                    {LabelShow("Vitals")}
                    <Row className="ml-0 my-2">
                      <Col size={["md-2"]} className="border-right">
                        <p className=" vital-topic mb-0 pb-">Blood Pressure</p>
                        <p className="vital-value">
                          {currentData?.blood_pressure || " - "}
                        </p>
                      </Col>

                      <Col size={["md-2"]} className="border-right">
                        <p className=" vital-topic mb-0 pb-0">Pulse</p>
                        <p className="vital-value">
                          {currentData?.pulse || " - "}
                        </p>
                      </Col>
                      <Col size={["md-2"]} className="border-right">
                        <p className=" vital-topic mb-0 pb-0">
                          Oxygen Saturation
                        </p>
                        <p className="vital-value">
                          {currentData?.oxygen_saturation || " - "}
                        </p>
                      </Col>
                      <Col size={["md-2"]} className="border-right">
                        <p className=" vital-topic mb-0 pb-0">Weight</p>
                        <p className="vital-value">
                          {currentData?.weight || " - "}
                        </p>
                      </Col>
                      <Col size={["md-2"]} className="border-right">
                        <p className=" vital-topic mb-0 pb-0">Height</p>
                        <p className="vital-value">
                          {currentData?.height || " - "}
                        </p>
                      </Col>
                    </Row>
                  </>
                )}
              {LabelShow("Notes")}
              <CustomTextArea
                value={
                  currentData?.notes?.length > 0 ? currentData?.notes : null
                }
                className={classnames(
                  editMode ? "mycontentdivMain" : "myoutline"
                )}
                error={form.notes}
                label={editMode ? "Note" : ""}
                disabled={editMode && currentData?.is_locked}
                onChange={val => setCurrentNoteData({ notes: val })}
                editMode={editMode}
              />

              {currentData?.notesImages?.length > 0 && (
                <div className={classnames("row px-3 pb-4")}>
                  {currentData?.deleteLoading ? (
                    <SpinnerBorder className="mx-auto" size="lg" />
                  ) : (
                    currentData?.notesImages?.map((imgs, i) => (
                      <div className="col-md-4">
                        <img
                          src={imgs}
                          alt={"viewEditScreenshots"}
                          className="screenshots img-fluid mb-2"
                        />
                        {editMode && (
                          <button
                            style={{
                              position: "absolute",
                            }}
                            className="button-style"
                            onClick={() => {
                              setCurrentNoteData({ deleteLoading: true });
                              deleteScreenshot(imgs);
                            }}
                          >
                            <ProfileIcon type="delete" />{" "}
                          </button>
                        )}
                      </div>
                    ))
                  )}{" "}
                </div>
              )}
              {/* images */}
              {LabelShow("Assessment")}
              <CustomTextArea
                value={currentData?.assessment|| ""}
                className={classnames(
                  editMode ? "mycontentdivMain" : "myoutline"
                )}
                error={form.assessment}
                label={editMode ? "Assessment" : ""}
                disabled={editMode && currentData?.is_locked}
                editMode={editMode}
                onChange={val => setCurrentNoteData({ assessment: val })}
              />

              {LabelShow("Plan")}
              <CustomTextArea
                value={currentData?.plan || ""}
                className={classnames(
                  editMode ? "mycontentdivMain" : "myoutline"
                )}
                error={form.plan}
                label={editMode ? "Plan" : ""}
                editMode={editMode}
                disabled={editMode && currentData?.is_locked}
                onChange={val => setCurrentNoteData({ plan: val })}
              />
              {currentData?.doctor_detail?.signature && (
                <table style={{ float: "right" }}>
                  <tbody>
                    <tr style={{ textAlign: "right" }}>
                      <img
                        src={currentData?.doctor_detail?.signature}
                        style={{
                          height: "125px",
                          paddingBottom: "6px",
                        }}
                      />
                    </tr>
                    <tr style={{ textAlign: "right" }}>
                      Dr. {currentData.doctor_first_name}{" "}
                      {currentData.doctor_last_name} ,{" "}
                      {currentData?.doctor_detail?.degree__degree}
                    </tr>
                    <tr style={{ textAlign: "right" }}>
                      {format(
                        new Date(currentData?.created_at),
                        "MMMM dd, yyyy"
                      )}
                    </tr>
                  </tbody>
                </table>
              )}

              {editMode ? (
                <div className="col-md-5 d-flex justify-content-between align-items-center px-2 mt-n3 pb-4">
                  <Button
                    onClick={() => setShowModal(true)}
                    label="Save"
                    className="mr-3 font-weight-normal"
                  />
                  <Button
                    type="outline"
                    label={"Cancel"}
                    onClick={closeModal}
                    className="btn-block font-weight-normal"
                  />
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </>
      </Modals>
    </>
  );
};

const mapStoreToProps = ({ dashboard, validation,}) => ({
  notes: dashboard?.patients?.allNotes,
  currentData: dashboard?.patients?.currentData,
  searchData: dashboard?.patients?.searchNotes,
  searchValue: dashboard.patients?.searchValue,
  form: validation?.data,
  total_pages: dashboard?.patients?.totalNotePages,
})
const mapDispatchToProps = dispatch => ({
  validateData: notes =>
    dispatch(actions.validateData(VALIDATE_TEMPLATE, notes)),
  getAllPatientNotes: (id, q, page) =>
    dispatch(actions.getAllPatientNotes(id, q, page)),
  searchPatientNotes: q => dispatch(actions.searchPatientNotes(q)),
  emptyPatientData: () => dispatch(actions.emptyPatientData()),
  editPatientNotes: (pid,lock) =>
    dispatch(actions.editPatientNotes(pid,lock)),
  setCurrentNoteImages: payload =>
    dispatch(actions.setCurrentNoteImages(payload)),
  setCurrentNoteData: payload => dispatch(actions.setCurrentNoteData(payload)),
  clearCurrentNoteData: () => dispatch(actions.clearCurrentNoteData()),
  deleteScreenshot: url => dispatch(actions.deleteScreenshot(url)),
  addNote: (cd,pid) =>
    dispatch(actions.addNote(cd,pid)),
    addTemplatesNote: (cd,pid) =>
    dispatch(actions.addTemplatesNote(cd,pid)),
  getAllTemplates: (q, page) => dispatch(actions.getAllTemlates(q, page)),
  setEditMode: () => dispatch(actions.setEditMode()),
  emptyTemplateData: () => dispatch(actions.emptyTemplateData()),
  searchTemplates: q => dispatch(actions.templateSearch(q))
});

export default withRouter(
  connect(mapStoreToProps, mapDispatchToProps)(CreateNotes ))

